module.exports = __webpack_public_path__ + "img/chimichurri.a1a3f40d.jpg";